import React, { useState } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core/styles';
import { toastr } from 'react-redux-toastr';
import moment from 'moment-timezone';
import 'moment/locale/pt-br';
import iconCopy from '../../../../../../assets/images/icon_copiar.svg';

moment.locale('pt-br');

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '5px',
    width: '295px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
  },
}));

const UpdateHistoryAction = ({ historyAction, handleClick, fusoName }) => {
  return (
    <li>
      <span>
        O registro{' '}
        <b>{`${historyAction.targetModelName} (${historyAction.targetModelId})`}</b>{' '}
        foi ATUALIZADO nos campos <b>{historyAction.updateTarget}</b> por{' '}
        <b>{historyAction.userName}</b> em{' '}
        <b>{moment.tz(historyAction.when, fusoName).format('LLL')}</b>
      </span>
      <div
        onClick={() => handleClick(historyAction._id)}
        className="audit-page-list-option"
      >
        &bull;&bull;&bull;
      </div>
    </li>
  );
};

const InsertHistoryAction = ({ historyAction, handleClick, fusoName }) => {
  return (
    <li>
      <span>
        O registro{' '}
        <b>{`${historyAction.targetModelName} (${historyAction.targetModelId})`}</b>{' '}
        foi INSERIDO por <b>{historyAction.userName}</b> em{' '}
        <b>{moment.tz(historyAction.when, fusoName).format('LLL')}</b>
      </span>
      <div
        onClick={() => handleClick(historyAction._id)}
        className="audit-page-list-option"
      >
        &bull;&bull;&bull;
      </div>
    </li>
  );
};

const DeleteHistoryAction = ({ historyAction, handleClick, fusoName }) => {
  return (
    <li>
      <span>
        O registro{' '}
        <b>{`${historyAction.targetModelName} (${historyAction.targetModelId})`}</b>{' '}
        foi REMOVIDO por <b>{historyAction.userName}</b> em{' '}
        <b>{moment.tz(historyAction.when, fusoName).format('LLL')}</b>
      </span>
      <div
        onClick={() => handleClick(historyAction._id)}
        className="audit-page-list-option"
      >
        &bull;&bull;&bull;
      </div>
    </li>
  );
};

const AnanonymizeHistoryAction = ({ historyAction, handleClick, fusoName }) => {
  return (
    <li>
      <span>
        O {historyAction.targetAnonymization} do registro{' '}
        <b>{`${historyAction.targetModelName} (${historyAction.targetModelId})`}</b>{' '}
        foi ANONIMIZADO por <b>{historyAction.userName}</b> em{' '}
        <b>{moment.tz(historyAction.when, fusoName).format('LLL')}</b>
      </span>
      <div
        onClick={() => handleClick(historyAction._id)}
        className="audit-page-list-option"
      >
        &bull;&bull;&bull;
      </div>
    </li>
  );
};

const ListHistoryActions = ({ historyActions, fusoName }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [registerId, setRegisterId] = useState(undefined);

  const handleOpen = (id) => {
    setRegisterId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const copyId = () => {
    navigator.clipboard.writeText(registerId);
    toastr.success('Sucesso', 'Dado copiado com sucesso!');
  };

  const result = historyActions.map((historyAction) => {
    let returnComponent = null;

    if (historyAction.action === 'UPDATE') {
      returnComponent = (
        <UpdateHistoryAction
          key={historyAction._id}
          historyAction={historyAction}
          handleClick={handleOpen}
          fusoName={fusoName}
        />
      );
    } else if (historyAction.action === 'INSERT') {
      returnComponent = (
        <InsertHistoryAction
          key={historyAction._id}
          historyAction={historyAction}
          handleClick={handleOpen}
          fusoName={fusoName}
        />
      );
    } else if (historyAction.action === 'DELETE') {
      returnComponent = (
        <DeleteHistoryAction
          key={historyAction._id}
          historyAction={historyAction}
          handleClick={handleOpen}
          fusoName={fusoName}
        />
      );
    } else if (historyAction.action === 'ANANONYMIZE') {
      returnComponent = (
        <AnanonymizeHistoryAction
          key={historyAction._id}
          historyAction={historyAction}
          handleClick={handleOpen}
          fusoName={fusoName}
        />
      );
    }

    return returnComponent;
  });

  return (
    <>
      <ul className="audit-page-list">{result}</ul>

      <Modal
        open={open}
        onClose={handleClose}
        className={classes.modal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <p>
              <strong>Detalhes da alteração:</strong>
            </p>
            <p>
              <b>ID:</b> {registerId}{' '}
              <img
                src={iconCopy}
                style={{ cursor: 'pointer' }}
                alt="Icone de copia"
                onClick={copyId}
              />
            </p>
            <p style={{ color: '#A8B1BF' }}>
              Para ter acesso as informações alteradas, entre em contato com a
              Code7, e informe este código.
            </p>

            <div className="container-btn-close-details-modal">
              <button
                className="btn-close-details-modal"
                onClick={handleClose}
                type="button"
              >
                Fechar
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default ListHistoryActions;
